// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox_container___ejBo"};